<div class="row">
  <div class="col-md-10">
      <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons"></i>
            </div>
            <h4 class="card-title">Change Rep</h4>
          </div>
          <div class="card-body">

<div mat-dialog-content>

     <form #userNewForm="ngForm">
                  <div class="row">
                    <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating">Client</label>
                    <input type="text" class="form-control"  placeholder="{{this.user.user.name}} {{this.user.user.surname}}"  disabled>
                  </div>
                  <div  class="form-group" *ngIf="loading == false">
                 
 <label class="bmd-label-floating">Switch REP to</label>
                                 <mat-form-field class="example-full-width">
    <input type="text" [(ngModel)]="this.user.new_user" placeholder="Select"  aria-label="Select" matInput [formControl]="myControlClientes" [matAutocomplete]="autoClientes" id="nameCliente">
    <mat-autocomplete  #autoClientes="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredClientes | async" [value]="option">
        
        {{option.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>



                  </div>
                  <mat-progress-bar style="width: 80%" *ngIf="loading" id="loadingbar" mode="indeterminate"></mat-progress-bar>
                </div>
              
               <div mat-dialog-actions>

  <button mat-button class="btn btn-success" [mat-dialog-close]="this.user" cdkFocusInitial>Save</button>
</div>
              </div>

              
    
          
             
              <div class="row">
                
               
                
              </div>
         
                </form>
                
  </div>
      </div>
  </div>
 
</div>

 



 
<div>

